import script from "./GeneralDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralDialog.vue?vue&type=script&setup=true&lang=js"

import "./GeneralDialog.vue?vue&type=style&index=0&id=98a30d98&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98a30d98"]])

export default __exports__